import { useMatchRoute } from "@tanstack/react-router";

export type ContentTab = "texts" | "docs" | "default-content";

export function tabToRoute(tab: ContentTab): "/$version/texts" | "/$version/docs" | "/$version/default-content" {
    if (tab === "docs") {
        return "/$version/docs";
    }
    if (tab === "default-content") {
        return "/$version/default-content";
    }
    return "/$version/texts";
}

export function useCurrentTab(): ContentTab {
    const matchRoute = useMatchRoute();

    if (matchRoute({ to: "/$version/docs", fuzzy: true })) {
        return "docs";
    }
    if (matchRoute({ to: "/$version/default-content", fuzzy: true })) {
        return "default-content";
    }
    return "texts";
}
